export const Umami = () => {
  return (
    <>
      {process.env.NEXT_PUBLIC_UMAMI_URL && (
        <script
          async
          src={`${process.env.NEXT_PUBLIC_UMAMI_URL}/script.js`}
          data-website-id={process.env.NEXT_PUBLIC_UMAMI_ID}
          type="text/javascript"
        ></script>
      )}
    </>
  )
}
